import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-leave-credit-auth-form',
  templateUrl: './leave-credit-auth-form.component.html',
  styleUrls: ['./leave-credit-auth-form.component.css']
})
export class LeaveCreditAuthFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/Leave-Credit/leave-credit-authorization/leave-credit-auth-form/leave-credit-auth-form.component.ts